export const archivedQuestionsConstants = {
  GET_ARCHIVED_QUESTIONS: "GET_ARCHIVED_QUESTIONS",
  REACTIVATE_QUESTION: "REACTIVATE_QUESTION",
  ARCHIVED_QUESTIONS: "archived-questions",
};
